export const BATSHIT_WINDOW_MS = 50;
export const BATSHIT_MAX_BATCH_SIZE = 100;
// A full 100-id batch overflows the ~2KB request-URI cap on a tRPC httpLink GET, truncating the query string and breaking JSON.parse server-side.
export const BATSHIT_URL_SAFE_MAX_BATCH_SIZE = 25;
